var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information-background"},[_c('div',{staticClass:"information-header container"},[_c('cms-block',{attrs:{"identifier":'header-first-time-info'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }